import { DetailedHTMLProps, HTMLAttributes, LinkHTMLAttributes, ReactNode } from 'react';

export enum LinkColors {
  Red = 'red',
  DarkBlack = 'darkBlack',
  Black = 'black',
  Violet = 'violet',
  Grey = 'grey',
  Breadcrumbs = 'breadcrumbs',
  DarkViolet = 'dark-violet',
}

export enum LinkTheme {
  Theme1 = 'theme1',
  Theme2 = 'theme2',
  Theme3 = 'theme3',
  Theme4 = 'theme4',
  Theme5 = 'theme5',
  Theme6 = 'theme6',
  Theme7 = 'theme7',
  Theme8 = 'theme8',
}

export interface BaseProps {
  children: ReactNode;
  className?: string;
  color?: LinkColors;
  themes?: LinkTheme;
  disabled?: boolean;
}

export type LinkType = BaseProps & DetailedHTMLProps<LinkHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
export type DiveType = BaseProps & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export interface PropsLink extends LinkType {
  href: string;
  target?: string;
  reloaded?: boolean;
}
